var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"map component"},[_c('el-amap',{staticClass:"amap",attrs:{"vid":"amap","zoom":_vm.zoom,"center":_vm.center}},_vm._l((_vm.markers),function(marker,index){return _c('el-amap-marker',{key:index,attrs:{"position":marker.position,"events":marker.events}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }